import { createStore as reduxCreateStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducer from '../reducers/';

const MIDDLEWARE = [thunk];

export default function createStore() {
  let enhancer;

  if (process.env !== 'production' && global.devToolsExtension) {
    enhancer = compose(global.devToolsExtension());
  }

  return applyMiddleware(...MIDDLEWARE)(reduxCreateStore)(reducer, enhancer);
}



// WEBPACK FOOTER //
// ./src/services/create_store.js